<ifc-base-dialog title="Add new competitor"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <ifb-competitor-form (formStatusChanged)="onFormStatusChanged($event)"></ifb-competitor-form>
  </ng-template>
</ifc-base-dialog>
